// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SurveySaveQuestionResultResponseModel {
    'nextQuestionId'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SurveySaveQuestionResultResponseModel>> = [
        {
            "name":     "nextQuestionId",
            "baseName": "nextQuestionId",
            "type":     "number"
        },
    ];

    static getAttributeTypeMap() {
        return SurveySaveQuestionResultResponseModel.attributeTypeMap;
    }
}
